export class SizeRequest{
    sizeId:number;
    
    constructor(sizeId:number){
        this.sizeId = sizeId;
    }
}

export class itemSubCatIdreq{
    itemSubcatId:number
    constructor(
    itemSubcatId:number
    ){
        this.itemSubcatId=itemSubcatId
    }
}